import React, {useState} from "react";

import {Field, Form, Formik} from "formik";
import {i18n} from 'translate/i18n'
import {useParams, useNavigate} from "react-router";
import * as Yup from "yup";

import {PopoverMessage} from "components/Tooltip";

const initialFormValues = {
    displayName: '',
    accountEnabled: false,
    profile: 1,
    email: '',
    alternative_email: '',
    status: false
}

const FormUsers = ({
                       handleEdit,
                       handleCreate,
                       handleDelete,
                       formValues = initialFormValues
                   }) => {

    let {id} = useParams();
    const navigate = useNavigate();

    const createEmail = (value) => {
        const newUser = value.replaceAll(' ', '.');
        setEmailSuzano(newUser+'@suzano.com.br')
    }

    const [emailSuzano, setEmailSuzano] = useState(id && formValues.email )

    const SignupSchema = Yup.object().shape({
        displayName: Yup.string().required(i18n.t('inputError.userName')),
    });
    return (
        <Formik
            enableReinitialize={true}
            initialValues={formValues}
            validationSchema={SignupSchema}
            onSubmit={(values, actions) => {
                setTimeout(() => {
                    actions.setSubmitting(false);
                    id ? handleEdit(values) : handleCreate(values)
                }, 500);
            }}
        >
            {({
                  values,
                  errors,
                  touched,
              }) => (

                <Form>
                    <div className="card mt-3 border-0 shadow-sm">
                        <div className="card-body">
                            <div className="row">
                                <div className="col">
                                    <div className="form-group">
                                        <label className="form-label text-bold">{i18n.t('user.name')}</label>
                                        <Field
                                            className="form-control"
                                            name="displayName"
                                            onBlur={(e) => !id && createEmail(e.target.value)}
                                        />
                                        {errors.displayName && touched.displayName ?
                                            <div className="text-sm text-danger">{errors.displayName}</div> : null}
                                    </div>

                                    <div className="form-group">
                                        <label className="form-label text-bold">{i18n.t('user.profile')}</label>
                                        <Field
                                            as="select"
                                            className="form-select"
                                            name="profile"
                                        >
                                            <option value="1">Administrador</option>
                                            <option value="2">Líder ESG</option>
                                            <option value="3">Respondente</option>
                                            <option value="4">Avesso</option>
                                            <option value="5">Suzano</option>
                                            <option value="6">Tradutor</option>
                                            <option value="7">Auditor</option>
                                        </Field>
                                    </div>

                                    <div className="form-group">
                                        <label className="form-label text-bold">
                                            E-mail Suzano
                                        </label>
                                        <input
                                            className="form-control text-start"
                                            value={emailSuzano}
                                            readOnly
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label className="form-label text-bold">
                                            E-mail alternativo
                                            <PopoverMessage
                                                label="Caso o usuário não possua uma caixa de e-mail suzano, informar o e-mail alternativo para recebimento de notificações.">
                                                <sup className="mx-1">
                                                    <i className="bi bi-question-circle text-primary" role="button"/>
                                                </sup>
                                            </PopoverMessage>
                                        </label>
                                        <Field
                                            className="form-control"
                                            name="alternative_email"
                                        />
                                    </div>

                                    <label className="form-label text-bold">{i18n.t('user.status')}</label>
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row justify-content-between">
                                                <div className="col-6">
                                                    {i18n.t('user.active')}
                                                </div>

                                                <div className="col-2">
                                                    <div className="form-check form-switch float-end">
                                                        <Field
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            name="accountEnabled"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="card-footer bg-white py-3">
                            <div className="d-flex gap-1 float-end">
                                {/*{id &&*/}
                                {/*    <button type="button" className="btn btn-danger  px-5 py-2"*/}
                                {/*            onClick={() => handleDelete(id)}>*/}
                                {/*        {i18n.t('buttons.delete')}*/}
                                {/*    </button>*/}
                                {/*}*/}

                                <button type="submit" className="btn btn-success px-5 py-2">
                                    {i18n.t('buttons.save')}
                                </button>
                            </div>
                            <button type="button" onClick={() => navigate('/users/list')}
                                    className="btn btn-secondary px-5 py-2">
                                {i18n.t('buttons.return')}
                            </button>
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    );
}

export default FormUsers
